function setEqualHeight() {
  if (window.innerWidth < 767) {
    document.querySelectorAll('.swiper_option_enable').forEach(swiper => {
      const items = swiper.querySelectorAll('.media-grid--item');
      let maxHeight = 0;

      // reset before measuring
      items.forEach(item => {
        item.style.height = 'auto';
      });

      // find tallest
      items.forEach(item => {
        const h = item.offsetHeight;
        if (h > maxHeight) maxHeight = h;
      });

      // apply tallest height
      items.forEach(item => {
        item.style.height = maxHeight + 'px';
      });
    });
  } else {
    // reset when screen is bigger
    document.querySelectorAll('.media-grid--item').forEach(item => {
      item.style.height = 'auto';
    });
  }
}

// run on load and resize
window.addEventListener('load', setEqualHeight);
window.addEventListener('resize', setEqualHeight);
